'use client';
import { motion } from 'framer-motion';

import useAudioRoutingStore from 'state/audioRoutingStore';

import S from './ProgressBar.module.scss';

import useTotalAudioDuration from 'hooks/useTotalAudioDuration';

export interface ProgressBarProps {}

const ProgressBar = () => {
  const { totalDuration, durations } = useTotalAudioDuration();
  const currentStep = useAudioRoutingStore(s => s.currentStep);
  const isAudioPlaying = useAudioRoutingStore(s => s.isPlaying);

  if (totalDuration === 0) return;

  // rounds percentages down
  // the error created by rounding is fixed onto the last element
  const percentageDurations = durations.map(
    (duration, index, arr) =>
      Math.floor((duration / totalDuration) * 100) +
      (index === arr.length - 1
        ? 100 -
          arr.reduce(
            (roundError, d) =>
              roundError + Math.floor((d / totalDuration) * 100),
            0
          )
        : 0)
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeInOut' }}
      className={S.ProgressBar}
    >
      {durations.map((duration, index) => (
        <div
          key={`progress-chunk-${index}-${currentStep}`}
          className={S.ChunkWrapper}
          style={{
            width: `${percentageDurations[index]}%`,
            background: index < currentStep ? 'white' : 'unset',
          }}
        >
          <span
            style={
              index < currentStep
                ? { transform: 'scaleX(100%)' }
                : {
                    animationDuration: `${duration}s`,
                    animationPlayState:
                      index === currentStep && isAudioPlaying
                        ? 'running'
                        : 'paused',
                  }
            }
            className={S.Chunk}
          />
        </div>
      ))}
    </motion.div>
  );
};

export default ProgressBar;
